<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-network-wired'"
          [title]="'Ip Address'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="dataConfig.form.get(['ipAddress'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['NetworkEditComponent', 'ipAddress'])"
          (undo)="undo(['ipAddress'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-network-wired'"
          [title]="'Proxy'"
          [config]="dataConfig.groupConfigs.groupConfigs[1].config"
          [form]="dataConfig.form.get(['proxy'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['NetworkEditComponent', 'proxy'])"
          (undo)="undo(['proxy'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
      <div class="width-33" *ngIf="(isServiceVideo()|async)">
        <storever-element-group
          [icon]="'fa-wifi'"
          [title]="'Wifi'"
          [config]="dataConfig.groupConfigs.groupConfigs[2].config"
          [form]="dataConfig.form.get(['wifi'])"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'wifi'}"
          (save)="save(['NetworkEditComponent', 'wifi'])"
          (undo)="undo(['wifi'])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
    </ul>
  </form>
</ng-template>
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex: 1 1 0">ipAddress dirty: {{dataConfig.form.get(['ipAddress']).dirty}}</pre>
  <pre style="flex: 1 1 0">proxy dirty: {{dataConfig.form.get(['proxy']).dirty}}</pre>
  <pre style="flex: 1 1 0">wifi dirty: {{dataConfig.form.get(['wifi']).dirty}}</pre>
</div>

